export {default as Logo} from './Logo.svg';
export {default as ReactNative} from './ReactNative.svg';
// export {default as AppStoreBadge} from './AppStoreBadge.svg';
// export {default as GooglePlayBadge} from './GooglePlayBadge.svg';
